import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-4">
              移动端
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50 mb-4">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6 max-w-[520px]">
              {appInfo.description}
            </p>
            <div className="flex flex-wrap gap-2 mb-8">
              {appInfo.features.map((feat) => (
                <span key={feat} className="px-3 py-1.5 text-xs font-medium rounded-lg bg-background-100 border border-background-200/50 text-foreground-300 whitespace-nowrap">
                  <i className="ri-check-line text-accent-400 mr-1"></i>
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <button className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border border-background-300 hover:border-background-400 text-foreground-200 hover:text-foreground-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-[220px] h-[400px] md:w-[280px] md:h-[500px] rounded-3xl overflow-hidden bg-background-100 border-4 border-background-200/50 shadow-2xl">
              <img
                src={appInfo.image}
                alt="黑料官网App移动端截图"
                title="黑料官网App"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}